import {injectable} from 'inversify';

import type {RefundModel} from './Refund.model';

import {BaseController} from '../../../core/domain/Base/Base.controller';

@injectable()
export class RefundController extends BaseController<RefundModel> {
  constructor() {
    super();
  }
}
